import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./styles/typography.css";
import "./App.css";
import App from "./App";
import injectContext from "./injectContext";
const AppWithContext = injectContext(App);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppWithContext />
  </React.StrictMode>,
);
